
/* START_TEMPLATE */
define('hbs!templates/layouts/footer',['hbs','hbs/handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers);
  


  return "<div id=\"linksRegion\" class=\"region links\">\n</div>";
  });
Handlebars.registerPartial('templates/layouts/footer', t);
return t;
});
/* END_TEMPLATE */
;
